import { render } from "./ListaQuestoes.vue?vue&type=template&id=f9ef5fa0&scoped=true&ts=true"
import script from "./ListaQuestoes.vue?vue&type=script&lang=ts"
export * from "./ListaQuestoes.vue?vue&type=script&lang=ts"

import "./ListaQuestoes.vue?vue&type=style&index=0&id=f9ef5fa0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ef5fa0"]])

export default __exports__